<template>
<div>
    <div class="canvas-wrapper">
        <P5Wrapper
            v-model="p5Instance"
            :sketch="(p, width, height) => previewShapeSketch(p, previewCode, scale, width, height)" />
    </div>
</div>
</template>

<script>
import P5Wrapper from '../components/P5Wrapper.vue';
import previewShapeSketch from '../sketches/previewShapeSketch.js';
import { onMounted, ref, watch } from 'vue';

export default {
    components: { P5Wrapper },

    props: {
        previewCode: {
            type: String,
            default: '',
        },

        scale: {
            type: Number,
            default: 1,
        }
    },

    setup(props) {
        const p5Instance = ref(null);

        // const { updatePreviewCode } = useP5Store();
        // const { previewCode } = storeToRefs(useP5Store());

        watch(() => props.previewCode, (val) => {
            updateCode(val);
        });

        const updateCode = (code) => {
            // updatePreviewCode(code);
            p5Instance.value.updateCode(code);
        };

        watch(() => props.scale, (val) => {
            updateScale(val);
        });

        const updateScale = (scale) => {
            // updatePreviewCode(code);
            p5Instance.value.updateScale(scale);
        };

        onMounted(() => {
            p5Instance.value.setFirstFrameCallback(() => {
                updateScale(props.scale);
            });
        });

        return { previewShapeSketch, updateCode, updateScale, p5Instance };
    },
};
</script>

<style scoped>
.canvas-wrapper {
  width: 100%; /* Adjust as needed */
  height: 200px; /* Adjust as needed */
  border: 2px solid #ccc; /* Optional: Visual border for debugging */
  position: relative;
}
</style>
